import { Container, Row, Col, Alert, Image } from 'react-bootstrap';

const ActivateMailMsg = () => {

    return (
        <div style={{ backgroundColor: '#29303d', width: '100%', height: '100vh', overflow: 'auto' }}>
            <Container>
                <Row className="justify-content-md-center text-center pt-4">
                    <Col sm="12" md="4">
                        <Image src="/images/floworglogo.png" style={{ width: '80%' }} />
                    </Col>
                </Row>

                <Row className="justify-content-md-center mt-5">
                    <Col sm="12" md="6">
                        <Alert variant="secondary">
                            <p style={{ fontWeight: 'bold', fontSize: '30px', textAlign: 'center' }}>Congratulations</p>
                            <p style={{ fontSize: '21px', textAlign: 'center' }}>
                                Your registration was done successfully.
                                Please check your Mailbox, you should receive mail from Floworg CRM to activate your account.
                            </p>
                        </Alert>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ActivateMailMsg;
